/**
 * Zod schemas for Claims validation
 */

import { z } from 'zod';
import type { Claims } from './types';

export const ClaimsSchema = z.object({
  phoneVerifExp: z.number().optional(),
  emailVerifExp: z.number().optional(),
  migrationProofExp: z.number().optional(),
});

/**
 * Validate and parse Claims from unknown JSON.
 * Returns Claims or null if invalid.
 */
export function parseClaimsFromJSON(data: unknown): Claims | null {
  const result = ClaimsSchema.safeParse(data);
  if (!result.success) {
    return null;
  }
  return result.data;
}
